import { render, staticRenderFns } from "./AColorPicker.vue?vue&type=template&id=b82c5b6c"
import script from "./AColorPicker.vue?vue&type=script&lang=js"
export * from "./AColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports